module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('img', {
    staticClass: "avatar image",
    class: _vm.proportion,
    attrs: {
      "src": _vm.url
    }
  })
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-e99ffb2e","hasScoped":true}!./src/components/avatar/template.html
// module id = 429
// module chunks = 1